var map = {
	"./2c.svg": "c932",
	"./2d.svg": "4bad",
	"./2h.svg": "0e47",
	"./2s.svg": "00df",
	"./3c.svg": "726e",
	"./3d.svg": "509d",
	"./3h.svg": "aed4",
	"./3s.svg": "77aa",
	"./4c.svg": "dacb",
	"./4d.svg": "533b",
	"./4h.svg": "8b37",
	"./4s.svg": "794b",
	"./5c.svg": "c816",
	"./5d.svg": "e87b",
	"./5h.svg": "a198",
	"./5s.svg": "bfe9",
	"./6c.svg": "cdd9",
	"./6d.svg": "603a",
	"./6h.svg": "db4d",
	"./6s.svg": "bb54",
	"./7c.svg": "986f",
	"./7d.svg": "23f0e",
	"./7h.svg": "c538",
	"./7s.svg": "acee",
	"./8c.svg": "9b14",
	"./8d.svg": "eb37",
	"./8h.svg": "828f",
	"./8s.svg": "4ba6",
	"./9c.svg": "1804",
	"./9d.svg": "8f91",
	"./9h.svg": "2e66",
	"./9s.svg": "dff5",
	"./ac.svg": "9561",
	"./ad.svg": "f007",
	"./ah.svg": "cb31",
	"./as.svg": "5dd6",
	"./back-solid-grey.svg": "a8b9",
	"./jc.svg": "9249",
	"./jd.svg": "f9f0",
	"./jh.svg": "dc30",
	"./js.svg": "f41c",
	"./kc.svg": "1746",
	"./kd.svg": "1a31",
	"./kh.svg": "df67",
	"./ks.svg": "7b20",
	"./qc.svg": "46ca",
	"./qd.svg": "4ef1",
	"./qh.svg": "3b37",
	"./qs.svg": "1a58",
	"./tc.svg": "aff3",
	"./td.svg": "3440",
	"./th.svg": "591a",
	"./ts.svg": "2cb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb40";